module.exports = __webpack_public_path__ + "static/img/dCT5.91444645.png";